import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import '../styles/sections.css';
import './Solution.css';

const checks = [
  '10-stage deterministic pipeline',
  '7 stages enforced by code — AI cannot bypass them',
  'Max-2 fix loop, then human escalation',
  'Self-hosted, fine-tuned open-source models',
  'Zero client data leaves your network',
  'Fixed annual cost instead of runaway per-token bills',
];

const pipeline = [
  { name: 'Context assembly', type: 'code' },
  { name: 'Planning', type: 'llm' },
  { name: 'Validation', type: 'code' },
  { name: 'Scaffolding', type: 'code' },
  { name: 'Generation', type: 'llm' },
  { name: 'Quality check', type: 'code' },
  { name: 'Fix loop', type: 'llm' },
  { name: 'Security scan', type: 'code' },
  { name: 'Testing', type: 'code' },
  { name: 'Packaging', type: 'code' },
];

export default function Solution() {
  return (
    <section id="solution" className="section">
      <div className="container">
        <div className="solutionWrapper">
          <div className="solutionCopy">
            <motion.span
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="sectionLabel"
            >
              The Keraunos Difference
            </motion.span>

            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="sectionTitle"
            >
              Blueprint-first. Deterministic by design.
            </motion.h2>

            <motion.p
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="sectionSubtitle"
            >
              Built on the Stripe Minions pattern that safeguards code supporting
              over $1 trillion in annual payment volume. Keraunos wraps the model
              in code-enforced quality gates the AI cannot skip, override, or
              silently ignore.
            </motion.p>

            <ul className="checkList">
              {checks.map((item, idx) => (
                <motion.li
                  key={item}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: 0.15 + idx * 0.06 }}
                >
                  <Check className="checkIcon" size={18} />
                  {item}
                </motion.li>
              ))}
            </ul>
          </div>

          <div className="pipelineVisual">
            {pipeline.map((step, idx) => (
              <motion.div
                key={step.name}
                initial={{ opacity: 0, x: 40 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: idx * 0.06 }}
                className="pipelineStep"
              >
                <span className={`stepNumber ${step.type === 'code' ? 'stepCode' : 'stepLLM'}`}>
                  {idx + 1}
                </span>
                <span className="stepName">{step.name}</span>
                <span className="stepType">{step.type}</span>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
